var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-icon",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 1.385,
    cy: 1.385,
    r: 1.385,
    transform: "translate(16.615 12)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8510",
    "data-name": "Path 8510",
    d: "M29.769,20.615a.92.92,0,0,0-.462-.795v-.59a3.231,3.231,0,1,0-6.462,0v.59a.92.92,0,0,0-.462.795v.68a5.077,5.077,0,1,0,7.385,0Zm-3.692-3.692a2.31,2.31,0,0,1,2.308,2.308v.6a.92.92,0,0,0-.3.278,5.057,5.057,0,0,0-4.014,0,.924.924,0,0,0-.3-.288v-.589A2.31,2.31,0,0,1,26.077,16.923Zm0,12a4.154,4.154,0,1,1,4.154-4.154A4.158,4.158,0,0,1,26.077,28.923Z",
    transform: "translate(-8.077 -11.385)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8511",
    "data-name": "Path 8511",
    d: "M18,6A12,12,0,1,0,30,18,12.014,12.014,0,0,0,18,6Zm0,23.077A11.077,11.077,0,1,1,29.077,18,11.09,11.09,0,0,1,18,29.077Z",
    transform: "translate(0 -6)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8512",
    "data-name": "Path 8512",
    d: "M29.846,31a1.84,1.84,0,0,0-.923,3.436v.257a.923.923,0,1,0,1.846,0v-.257A1.84,1.84,0,0,0,29.846,31Zm0,2.769a.923.923,0,1,1,.923-.923A.924.924,0,0,1,29.846,33.769Z",
    transform: "translate(-11.846 -19.462)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8513",
    "data-name": "Path 8513",
    d: "M20.154,10A10.154,10.154,0,1,0,30.308,20.154,10.165,10.165,0,0,0,20.154,10Zm0,19.385a9.231,9.231,0,1,1,9.231-9.231A9.241,9.241,0,0,1,20.154,29.385Z",
    transform: "translate(-2.154 -8.154)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.24b8429cc80e3cd58c27056530a604b2.svg";
export { ForwardRef as ReactComponent };